/** Site genelinde tek kaynak: telefon, e-posta, adres linkleri */
export const CONTACT_PHONE_DISPLAY = '+90 (507) 244 52 04';
export const CONTACT_PHONE_TEL = 'tel:+905072445204';

export const CONTACT_EMAIL = 'info@sultanlarbesicilik.com';
export const CONTACT_MAILTO = `mailto:${CONTACT_EMAIL}`;

export const CONTACT_ADDRESS_DISPLAY = 'Çendik Köyü Burdur';
export const CONTACT_MAPS_URL =
  'https://www.google.com/maps/search/?api=1&query=' +
  encodeURIComponent('Çendik Köyü Burdur Türkiye');

export const CONTACT_INSTAGRAM_URL =
  'https://www.instagram.com/burdursultanlarbesiciftligi/';
